import { Alert } from '@mui/material';
import React from 'react';

export function AlerteAction(etat:string, type:string){
    switch(etat){
            case 'Add':
                return (
                    <Alert
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {type} a bien été ajouté(e) !
                    </Alert>
                )
            case 'Edit':
                return (
                    <Alert
                        severity="info"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {type} a bien été modifié(e) !
                    </Alert>
                )
            case 'Delete':
                return (
                    <Alert
                        severity="warning"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {type} a bien été supprimé(e) !
                    </Alert>
                )
            case 'Neutre':
                return (
                    <Alert
                        severity="info"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        Aucune modification et aucun message commandé
                    </Alert>
                )
            default:
                return (
                    <Alert
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        Erreur lors de votre action !!
                    </Alert>
                );
    }
}
